import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58.16 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51-28.166 0-51 22.834-51 51 0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M38.4 110.79c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path fill="#D8FFFF" d="M84.69 16.53a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="M5.4 53.23a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M21.62 14.03l3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM112.63 64.26h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M29.99 26h56.03c4.41 0 7.99 3.51 7.99 7.82V78H22V33.82C22 29.5 25.58 26 29.99 26"
    />
    <path
      fill="#0597A3"
      d="M12 78h92v6.51c0 4.13-3.33 7.49-7.43 7.49H19.43c-4.1 0-7.43-3.35-7.43-7.49zM66 37.25H50c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h16c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
    <path
      fill="#D8FFFF"
      d="M44.75 57.52c-.58 0-1.15-.22-1.59-.66-.88-.88-.88-2.3 0-3.18L54.24 42.6c.88-.88 2.3-.88 3.18 0s.88 2.3 0 3.18L46.34 56.86c-.44.44-1.02.66-1.59.66M58.16 73.02c-.58 0-1.15-.22-1.59-.66-.88-.88-.88-2.3 0-3.18L67.65 58.1c.88-.88 2.3-.88 3.18 0s.88 2.3 0 3.18L59.75 72.36c-.44.44-1.02.66-1.59.66M45 71.38c-.58 0-1.15-.22-1.59-.66-.88-.88-.88-2.3 0-3.18L66.3 44.65c.88-.88 2.3-.88 3.18 0s.88 2.3 0 3.18L46.59 70.72c-.44.44-1.02.66-1.59.66"
    />
  </svg>
);
const SvgEnrichedIconWebBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconWebBrand);
export default Memo;
